module.exports = __webpack_public_path__ + "img/align_right.37ebedcd.svg";